import Box from "@mui/material/Box";
import { useAuthUser } from "../features/authContext";
import CurrentSvadbaTime from "./CurrentSvadbaTime";

const HeaderTimeBar = () => {
	const user = useAuthUser();
	if (!user) return null;

	return (
		<Box
			sx={{
				width: "100%",
				bgcolor: (theme) =>
					theme.palette.mode === "dark"
						? "rgba(18,27,23,0.72)"
						: "rgba(255,255,255,0.72)",
				borderBottom: "1px solid",
				borderColor: "divider",
				py: 2,
				px: { xs: 1, sm: 2 },
				display: "flex",
				alignItems: "center",
				justifyContent: "flex-end",
			}}
		>
			<CurrentSvadbaTime variant="caption" />
		</Box>
	);
};

export default HeaderTimeBar;
